export const COMPANY_BANKS = {
  data: [
    {
      id: 'bf7646ba-320a-4c5e-816d-447d4b3e2fad',
      display_name: {
        'en-US': 'BANGKOK BANK',
        'th-TH': 'ธนาคารกรุงเทพ'
      },
      bank_logo_url: null,
      sequence: 1,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '2c378374-380c-4b70-8c64-6a021920918a',
      display_name: {
        'en-US': 'KASIKORNBANK',
        'th-TH': 'ธนาคารกสิกรไทย'
      },
      bank_logo_url: null,
      sequence: 2,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '1c16f3fd-4984-4949-8880-9ff412d89027',
      display_name: {
        'en-US': 'KRUNG THAI BANK',
        'th-TH': 'ธนาคารกรุงไทย'
      },
      bank_logo_url: null,
      sequence: 3,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'aa97a1a6-599f-4b92-b567-93f82e19e09e',
      display_name: {
        'en-US': 'Siam Commercial Bank',
        'th-TH': 'ธนาคารไทยพาณิชย์'
      },
      bank_logo_url: null,
      sequence: 5,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'bfa37358-7d53-4478-bc19-1ecb328368e6',
      display_name: {
        'en-US': 'BANK OF AYUDHYA',
        'th-TH': 'ธนาคารกรุงศรีอยุธยา'
      },
      bank_logo_url: null,
      sequence: 6,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'd12d93f9-1ae8-4c90-9410-4b3395810609',
      display_name: {
        'en-US': 'KIATNAKIN PHATRA BANK PUBLIC COMPANY LIMITED',
        'th-TH': 'ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)'
      },
      bank_logo_url: null,
      sequence: 7,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'b3d7c7d8-2339-45a2-9f8a-0a7da0bb22e0',
      display_name: {
        'en-US': 'Thai Military Bank',
        'th-TH': 'ธนาคารทหารไทย'
      },
      bank_logo_url: null,
      sequence: 8,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'f0f2f8d4-6aa0-4dc2-80e8-3069e4353b5e',
      display_name: {
        'en-US': 'CIMB Bank',
        'th-TH': 'ธนาคารซีไอเอ็มบี'
      },
      bank_logo_url: null,
      sequence: 8,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'a3519310-9531-4ed2-84e6-6cbc4e395acc',
      display_name: {
        'en-US': 'Tisco Bank Public Company Limited',
        'th-TH': 'ธนาคารทิสโก้'
      },
      bank_logo_url: null,
      sequence: 9,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '23eeb0dc-283e-4b95-8280-11385cc79ccf',
      display_name: {
        'en-US': 'Industrial and Commercial Bank of China (Thai)',
        'th-TH': 'ธนาคารไอซีบีซี (ไทย)'
      },
      bank_logo_url: null,
      sequence: 10,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '8805e69b-51e0-4b9b-8896-67fbdb57d0a1',
      display_name: {
        'en-US': 'STANDARD CHARTERED BANK (THAI)',
        'th-TH': 'ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย'
      },
      bank_logo_url: null,
      sequence: 10,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'c5a31e16-24d9-4cca-ab0e-f69849c6f458',
      display_name: {
        'en-US': 'United Overseas Bank (Thai)',
        'th-TH': 'ธนาคารยูโอบี'
      },
      bank_logo_url: null,
      sequence: 11,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'c5d0883a-1287-4b86-ba8b-4f29ad9a05c3',
      display_name: {
        'en-US': 'Thai Credit Retail Bank Public Company Limited',
        'th-TH': 'ธนาคารไทยเครดิตเพื่อรายย่อย'
      },
      bank_logo_url: null,
      sequence: 13,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '87a3b725-43f7-4a38-bc3a-04897b2ab292',
      display_name: {
        'en-US': 'Land and Houses Bank',
        'th-TH': 'ธนาคารแลนด์ แอนด์ เฮ้าส์'
      },
      bank_logo_url: null,
      sequence: 14,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '6c6deccc-e2d5-4049-9361-7a0fc05e3311',
      display_name: {
        'en-US': 'Bank for Agriculture and Agricultural Cooperatives',
        'th-TH': 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)'
      },
      bank_logo_url: null,
      sequence: 17,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'fea56e51-d0b7-45da-b740-a1c0a8a16838',
      display_name: {
        'en-US': 'Government Savings Bank',
        'th-TH': 'ธนาคารออมสิน'
      },
      bank_logo_url: null,
      sequence: 19,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '00466d84-8b5e-47c0-b837-3d2c9e72d191',
      display_name: {
        'en-US': 'Government Housing Bank',
        'th-TH': 'ธนาคารอาคารสงเคราะห์'
      },
      bank_logo_url: null,
      sequence: 20,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'f7c73bc9-fc67-4362-a865-0bb996792c39',
      display_name: {
        'en-US': 'Islamic Bank Of Thailand',
        'th-TH': 'ธนาคารอิสลามแห่งประเทศไทย'
      },
      bank_logo_url: null,
      sequence: 21,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'f1fc7fa6-40eb-4ed3-8e0d-29cd7f723696',
      display_name: {
        'en-US': 'Bank of China',
        'th-TH': 'ธนาคารแห่งประเทศจีน'
      },
      bank_logo_url: null,
      sequence: 22,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '35a1d4c0-62fc-42e1-a2bf-644607f03169',
      display_name: {
        'en-US': 'SUMITOMO MITSUI BANKING',
        'th-TH': 'ธนาคาร ซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น'
      },
      bank_logo_url: null,
      sequence: 23,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '62a1bab8-c0fd-4bc3-b70c-f1269904ec4d',
      display_name: {
        'en-US': 'HONGKONG AND SHANGHAI BANKING',
        'th-TH': 'เอชเอสบีซี'
      },
      bank_logo_url: null,
      sequence: 24,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '96d81898-b568-4ff0-948b-85160bee9bbc',
      display_name: {
        'en-US': 'Citibank N.A.',
        'th-TH': 'ธนาคารซิตี้แบงก์'
      },
      bank_logo_url: null,
      sequence: 25,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '631d1308-81a4-4050-90f0-826a30c0e853',
      display_name: {
        'en-US': 'Mizuho Bank Bangkok Branch',
        'th-TH': 'ธนาคารมิซูโฮ'
      },
      bank_logo_url: null,
      sequence: 26,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '3a78464d-9229-4e8b-963d-a7b10e904d89',
      display_name: {
        'en-US': 'INDIAN OVERSEAS BANK',
        'th-TH': 'ธนาคาร อินเดียนโอเวอร์ซีส์'
      },
      bank_logo_url: null,
      sequence: 26,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '9232a532-b1a0-4b32-9f97-1f087347ee8c',
      display_name: {
        'en-US': 'BNP PARIBAS, BANGKOK BRANCH',
        'th-TH': 'ธนาคาร บีเอ็นพี พารีบาส์'
      },
      bank_logo_url: null,
      sequence: 27,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '0356ba66-7808-4a3b-8365-7769826dd7f2',
      display_name: {
        'en-US': 'DEUTSCHE BANK AG',
        'th-TH': 'ธนาคารดอยซ์แบงก์ เอจี'
      },
      bank_logo_url: null,
      sequence: 28,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '08b6e95f-4ca8-4ef6-b902-c2341e5035e1',
      display_name: {
        'en-US': 'ANZ Bank (Thai) Public Company Limited',
        'th-TH': 'ธนาคารเอเอ็นแซด (ไทย) จำกัด(มหาชน)"'
      },
      bank_logo_url: null,
      sequence: 29,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'f40de9e2-55ee-44ae-998e-accd215bcd84',
      display_name: {
        'en-US': 'True Money Wallet',
        'th-TH': 'ทรูมันนี่'
      },
      bank_logo_url: null,
      sequence: 30,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '89724a40-a3ac-4abb-9c19-5a09543dd89f',
      display_name: {
        'th-TH': 'ธนาคารแห่งประเทศไทย',
        'en-US': 'BANK OF THAILAND'
      },
      bank_logo_url: null,
      sequence: 445,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '49ec5c67-62a9-49cf-bf48-bcf730594d0e',
      display_name: {
        'en-US': 'STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED'
      },
      bank_logo_url: null,
      sequence: 446,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'f1344894-f720-43f8-9c2e-03d806001cfe',
      display_name: {
        'en-US': 'JP Morgan'
      },
      bank_logo_url: null,
      sequence: 489,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '48bd0e3e-b5e7-4bcf-9ada-54a2c50be85c',
      display_name: {
        'en-US': 'SMBC Thailand'
      },
      bank_logo_url: null,
      sequence: 490,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '9fd3dc30-7e59-4572-9539-97d6fbee6d36',
      display_name: {
        'en-US': 'RHB'
      },
      bank_logo_url: null,
      sequence: 491,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '9b66302f-e65b-4d00-8a19-7bfd76e3c2ad',
      display_name: {
        'en-US': 'Bank Of America Thailand'
      },
      bank_logo_url: null,
      sequence: 492,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '7afb53ac-27fc-4b5c-86ec-6d1b6ad4c14c',
      display_name: {
        'en-US': 'Export-Import Bank of Thailand'
      },
      bank_logo_url: null,
      sequence: 493,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '5ba692c4-3bc1-4958-9176-c1ce59b32dc6',
      display_name: {
        'en-US': 'Mizuho Bank'
      },
      bank_logo_url: null,
      sequence: 494,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'cb967ee4-28fa-4431-9142-04a70cd1c6c7',
      display_name: {
        'en-US': 'BNP Paribas in Thailand'
      },
      bank_logo_url: null,
      sequence: 495,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: '59e4a7b8-5e9d-45c0-be6e-149ef4eac459',
      display_name: {
        'en-US': 'Mega ICBC Bank'
      },
      bank_logo_url: null,
      sequence: 496,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'ab6786c6-a7a5-4995-8bf5-a41719f539f6',
      display_name: {
        'en-US': 'Oversea-Chinese Banking Corporation'
      },
      bank_logo_url: null,
      sequence: 496,
      country_codes: ['TH'],
      supported_currency: ['THB']
    },
    {
      id: 'ab6786c6-a7a5-4995-8bf5-a41719f539f1',
      display_name: {
        'en-US': 'SME D Bank'
      },
      bank_logo_url: null,
      sequence: 496,
      country_codes: ['TH'],
      supported_currency: ['THB']
    }
  ]
}
